export default "https://static.wetvinfo.com/tv/linux/static/media/setUp_s.png";